<template>
  <div>
    <b-container>
      <h2 class="my-5">{{ $t('placesChoice.title') }}</h2>

      <b-row class="text-center my-5">
        <b-col cols="9" class="mx-auto">
          <b-form-input v-model="searchForm.query" type="search" :placeholder="$t('common.search')"></b-form-input>
        </b-col>
      </b-row>

      <b-row class="text-center my-5" v-if="0 === filteredPlaces.length">
        <b-col cols="9" class="mx-auto">
          <div v-if="this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.no_place_found_html')"
            v-html="this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.no_place_found_html')">
          </div>
          <div v-else>
            <b-alert show variant="warning">
              {{ $t('placesChoice.search.noPlace') }}
            </b-alert>
          </div>
        </b-col>
      </b-row>

      <b-list-group class="text-uppercase places-list">
        <b-list-group-item v-for="place in filteredPlaces" :key="place.id"
          @click="selectPlace(place)" href="javascript:;" :data-place-id="place.id" :data-place-code="place.code">
          {{ place.label }}
        </b-list-group-item>
      </b-list-group>
    </b-container>
  </div>
</template>

<script>
  import ApiService from '../../services/api'

  export default {
    data() {
      return {
        searchForm: {
          query: undefined,
        },
        places: [],
      }
    },

    methods: {
      selectPlace(place) {
        const queryParams = this.lodash.merge(this.$route.query, {
          pc: place.code,
          ref: 'pc',
        })
        this.$store.dispatch('setPlaceCode', place.code)

        return this.$router.push({ name: 'home', query: queryParams })
      },
    },

    computed: {
      filteredPlaces() {
        let places = this.places

        if (this.searchForm.query) {
          places = places.filter(place => {
            return -1 < place.label.toLowerCase().indexOf(this.searchForm.query.toLowerCase())
          })
        }

        if (this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.displayedPlaceCodes')) {
          const displayedPlacesCodes = this.lodash.get(this.$store.state.placeContext, 'workshop_parameters.front.displayedPlaceCodes');
          places = this.lodash.filter(places, function(place) {
            return displayedPlacesCodes.includes(parseInt(place.code))
          });
        }

        return this.lodash.orderBy(places, ['label'], ['asc'])
      },
    },

    mounted() {
      if (this.$route.query.pc) {
        return this.$router.push({ name: 'home', query: this.$route.query })
      }

      ApiService.fetchPlaces()
        .then(places => {
          this.places = places.data
        })
    }
  }
</script>
